import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { TimelineTransportSocketService } from '../../services/timeline-transport-socket.service';
import { TimelineTransportStateService } from '../../services/timeline-transport-state.service';

@Component({
    selector: 'app-timeline-transport-chat',
    templateUrl: './timeline-transport-chat.component.html',
    styleUrls: ['./timeline-transport-chat.component.scss'],
    standalone: false
})
export class TimelineTransportChatComponent implements OnInit, AfterViewChecked {

  @ViewChild('messageList') messageList: ElementRef<HTMLDivElement>;

  isOpen: boolean = false;
  messages: any[] = [];
  unreadCount: number = 0;
  newMessageText: string = '';
  currentUserId: number;

  // Only scroll after a message is actually appended, not on every change-detection pass -
  // messageList.scrollHeight is only meaningful once the new message has rendered.
  private shouldScrollToBottom: boolean = false;

  constructor(
    private authService: AuthService,
    private timelineTransportSocketService: TimelineTransportSocketService,
    private timelineTransportStateService: TimelineTransportStateService) { }

  ngOnInit(): void {
    this.currentUserId = this.authService.getUser().id;

    // This panel is always mounted as a page-level sibling, so its ngOnInit can run before (or
    // after) the main grid component's own ngOnInit, which is what normally calls connect() -
    // chatHistory$/chatMessage$ read this.socket directly and throw on a still-null socket if
    // this runs first. connect() already no-ops if a socket exists, so calling it here too is
    // safe regardless of which component's ngOnInit wins the race.
    this.timelineTransportSocketService.connect();

    this.timelineTransportSocketService.chatHistory$.subscribe((history: any[]) => {
      this.messages = history;
      this.shouldScrollToBottom = true;
    });

    this.timelineTransportSocketService.chatMessage$.subscribe((message: any) => {
      this.messages.push(message);
      this.shouldScrollToBottom = true;

      // Own messages come back over the same broadcast the gateway sends everyone else, so don't
      // count them as "unread" against the very user who just sent them.
      if (!this.isOpen && message.userId !== this.currentUserId) {
        this.unreadCount++;
        this.timelineTransportStateService.$transportChatUnreadCountChanged.next(this.unreadCount);
      }
    });

    this.timelineTransportStateService.$transportChatPanelToggled.subscribe(() => {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.unreadCount = 0;
        this.timelineTransportStateService.$transportChatUnreadCountChanged.next(0);
        this.shouldScrollToBottom = true;
      }
    });
  }

  ngAfterViewChecked(): void {
    if (this.shouldScrollToBottom && this.messageList) {
      this.messageList.nativeElement.scrollTop = this.messageList.nativeElement.scrollHeight;
      this.shouldScrollToBottom = false;
    }
  }

  sendMessage(): void {
    const text = this.newMessageText.trim();

    if (!text) {
      return;
    }

    this.timelineTransportSocketService.sendChatMessage(text);
    this.newMessageText = '';
  }

  getAvatarUrl(message: any): string {
    return 'https://eu.ui-avatars.com/api/?name=' + message.firstName + '+' + message.lastName + '&size=28';
  }

  isOwnMessage(message: any): boolean {
    return message.userId === this.currentUserId;
  }

  close(): void {
    this.isOpen = false;
  }
}
